<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-8 col-lg-3 col-xl-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              id="sel_farm"
              @clear="
                farm_id = null;
                renderer = false;
                hotSettings.data = [];
              "
              clearable
              @change="loadFiles"
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-12 col-sm-6 col-md-8 col-lg-5 col-xl-5"
            v-if="farm_id"
          >
            <label>{{ $t('common_words.file') }} *</label>
            <br />
            <el-select
              @change="loadData"
              @clear="cleanFileList()"
              clearable
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-file shadow-sm"
              size="large"
              v-model="file_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in filesList"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-2"
            v-if="
              file_sel &&
              farm_id &&
              clusters_names == null &&
              lots_names == null
            "
          >
            <l-button
              wide
              type="info"
              class="btn-filter shadow-sm"
              style="margin-top: 30px"
              @click="validate"
            >
              {{ $t('common_words.save') }}
            </l-button>
          </div>
          <!--Demo-->
          <div class="col-2" v-if="farm_id == 75">
            <!--Produccion-->
            <!--<div
            class="col-2"
            v-if="farm_id == 3"
          >-->
            <l-button
              wide
              type="primary"
              class="btn-filter shadow-sm"
              style="margin-top: 30px"
              @click="syncScalesClusters"
            >
              {{ $t('common_words.synchronize') }}
            </l-button>
          </div>
        </div>
        <br />
      </card>
      <card class="custom-shadow-card-header" v-if="renderer">
        <br />
        <div class="row">
          <div class="col-12 mb-4">
            <h5>
              <strong>1. {{ $t('common_words.file_info') }}</strong>
            </h5>
            <p>{{ $t('common_words.file_selected_info') }}</p>
          </div>
        </div>
        <div class="selArchBasc">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-6 text-center">
              <p
                class="filetittle"
                style="background-color: #4f8949; color: white"
              >
                <strong>{{ $t('common_words.file_information') }}</strong>
              </p>
              <p class="mb-1">
                <strong>{{ $t('common_words.farm') }}:</strong>
                {{ content_file.farm }}
              </p>
              <p class="mb-1">
                <strong>{{ $t('common_words.name') }}:</strong>
                {{ content_file.name_file }}
              </p>
              <p class="mb-1">
                <strong>{{ $t('common_words.date') }}:</strong>
                {{ content_file.date_file }}
              </p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 text-center">
              <p
                class="filetittle"
                style="background-color: #4f8949; color: white"
              >
                <strong>{{ $t('production.associated_ribbons') }}</strong>
              </p>
              <div>
                <div class="row">
                  <div
                    class="col-xs-3 col-sm-3 col-md-3"
                    v-for="r in content_file.content_ribbons"
                    :key="r.id"
                  >
                    <div
                      :style="
                        'border: 1px solid #c3c3c3;background-color: ' +
                        r.color_code +
                        ';color:' +
                        r.color_code
                      "
                    >
                      {{ r.id }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-2 col-md-2"></div>
            <div class="col-sm-2 col-md-2">
              <div class="cuadrado-m gray-fondo">
                <h5 class="margin5" style="font-size: 14px">
                  {{ $t('production.min_weight') }}
                </h5>
                <h5 id="lstPesoMin" class="margin5" style="font-size: 15px">
                  <strong>{{ formatValue(content_file.min_weight) }}</strong>
                </h5>
              </div>
            </div>
            <div class="col-sm-2 col-md-2">
              <div class="cuadrado-m gray-fondo">
                <h5 class="margin5" style="font-size: 14px">
                  {{ $t('production.max_weight') }}
                </h5>
                <h5 id="lstPesoMax" class="margin5" style="font-size: 15px">
                  <strong>{{ formatValue(content_file.max_weight) }}</strong>
                </h5>
              </div>
            </div>
            <div class="col-sm-2 col-md-2">
              <div class="cuadrado-m gray-fondo">
                <h5 class="margin5" style="font-size: 14px">
                  {{ $t('common_words.average') }}
                </h5>
                <h5 id="lstPesoProm" class="margin5" style="font-size: 15px">
                  <strong>{{ formatValue(content_file.avg_weight) }}</strong>
                </h5>
              </div>
            </div>
            <div class="col-sm-2 col-md-2">
              <div class="cuadrado-m gray-fondo">
                <h5 class="margin5" style="font-size: 14px">
                  {{ $t('common_words.records') }}
                </h5>
                <h5 id="totalRegistros" class="margin5" style="font-size: 15px">
                  <strong>{{ formatValue(content_file.total) }}</strong>
                </h5>
              </div>
            </div>
            <div class="col-sm-2 col-md-2"></div>
          </div>
        </div>
        <hr />
        <div class="col-12 mt-4 mb-4">
          <h5>
            <strong>2. {{ $t('common_words.file_content') }}</strong>
          </h5>
          <p>{{ $t('production.scale_cluster_selected') }}</p>
        </div>
        <div
          class="alert alert-success"
          role="alert"
          v-show="!errorMessage && clusters_names == null && lots_names == null"
        >
          {{ $t('common_words.file_success') }}
        </div>
        <div
          class="alert alert-danger"
          role="alert"
          v-show="clusters_names != null || lots_names != null || errorMessage"
        >
          <br />
          <strong>{{ $t('common_words.file_error') }}</strong
          ><br />
          {{ $t('production.causes') }}:
          <p v-show="errorMessage">{{ errorMessage }}</p>
          <ol>
            <li v-show="clusters_names != null">
              {{ $t('production.the_s') }}
              <em>{{ $t('production.ribbon_s') }} {{ clusters_names }}</em>
              {{ $t('production.is_not_associated_farm') }}
              <em>{{ content_file.farm }}</em>
            </li>
            <li v-show="lots_names != null">
              {{ $t('production.the_s2') }}
              <em>{{ $t('common_words.allotment(s)') }} {{ lots_names }}</em>
              {{ $t('production.is_not_associated_farm')
              }}<em>{{ content_file.farm }}</em>
            </li>
          </ol>
        </div>
        <div class="row mb-4">
          <div class="col-12 text-center">
            <l-button
              wide
              type="info"
              class="btn-filter shadow-sm"
              @click="validateFile"
            >
              {{ $t('common_words.validate_file') }}
            </l-button>
          </div>
        </div>
        <div class="row">
          <div
            class="col-12 hot"
            v-if="hotSettings.data.length > 0"
            ref="handsontable"
          >
            <hot-table
              style="border-bottom: 1px solid #ccc"
              :settings="hotSettings"
              class="table-clusters"
            ></hot-table>
          </div>
          <div v-else>
            <h5>{{ $t('common_words.invalid_file') }}</h5>
          </div>
        </div>
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { HotTable } from '@handsontable/vue';
import { mapActions } from 'vuex';
import { MixinComputed } from './mixin-computed';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import Formatter from 'src/class/Formatter';
import Handsontable from 'handsontable';
import i18n from 'src/i18n';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

Handsontable.renderers.registerRenderer(
  'colorRenderer',
  function (hotInstance, td, row, column, prop, value, cellProperties) {
    Handsontable.renderers.NumericRenderer.apply(this, arguments);
    if (value == '') {
      td.classList = ['alert', 'alert-danger'];
    }
  }
);

export default {
  components: {
    [HotTable.name]: HotTable,
  },

  data() {
    return {
      errorMessage: null,
      message: null,
      content_file: [],
      filesList: [],
      farm_id: null,
      user_id: this.$store.state.auth.user.id,
      farms: [],
      file_sel: null,
      renderer: false,
      clusters_names: '',
      lots_names: '',
      hotSettings: {
        rowHeaders: true,
        colHeaders: [],
        columns: [
          {
            data: 0,
            readOnly: true,
          },
          {
            data: 1,
            readOnly: true,
          },
          {
            data: 2,
          },
          {
            data: 3,
            type: 'numeric',
          },
          {
            data: 4,
          },
          {
            data: 5,
          },
          {
            data: 6,
          },
          {
            data: 7,
          },
          {
            data: 8,
          },
          {
            data: 9,
          },
          {
            data: 10,
            readOnly: true,
          },
          {
            data: 11,
            readOnly: true,
          },
          {
            data: 12,
            readOnly: true,
          },
        ],
        stretchH: 'all',
        data: [],
        autoRowSize: false,
        autoColumnSize: false,
        columnSorting: true,
        contextMenu: true,
        height: 600,
        afterScrollVertically: function (row, col, prop) {
          setTimeout(() => {
            const all = document
              .getElementsByClassName('htCore')[0]
              .getElementsByTagName('tbody')[0]
              .getElementsByTagName('tr');

            Array.from(all).forEach((item) => {
              let cluster = item.getElementsByTagName('td')[2];
              let ribbon = item.getElementsByTagName('td')[1];
              let lot = item.getElementsByTagName('td')[3];

              if (cluster.innerText != '') {
                const arr = Object.values(
                  JSON.parse(sessionStorage.getItem('affiliates'))
                );
                for (let element of arr) {
                  if (element.color_name == cluster.innerText.toUpperCase()) {
                    cluster.style.background = element.color_code;
                    cluster.style.color = element.color_text;
                    ribbon.style.background = element.color_code;
                    ribbon.style.color = element.color_text;
                    ribbon.innerText = element.id;
                    cluster.innerText = element.color_name;
                    break;
                  }
                }
              }

              if (
                cluster.innerText == '' ||
                Object.values(
                  JSON.parse(sessionStorage.getItem('ribbons_errors'))
                ).includes(cluster.innerText)
              ) {
                cluster.className = 'alert alert-danger';
              } else {
                cluster.className = '';
              }

              if (
                !Number.isInteger(parseInt(lot.innerText)) ||
                lot.innerText == '' ||
                Object.values(
                  JSON.parse(sessionStorage.getItem('lots_errors'))
                ).includes(parseInt(lot.innerText))
              ) {
                lot.className = 'alert alert-danger';
              } else {
                lot.className = '';
              }
            });
          }, 1000);
        },
        afterRemoveRow: function (index, amount, physicalRows, source) {
          let data = this.getData();
          physicalRows.forEach((element) => {
            data.splice(element, 1);
          });
        },
      },
    };
  },

  mixins: [
    MixinPermissions,
    MixinMasters,
    MixinNotification,
    MixinExport,
    MixinMenu,
    MixinComputed,
  ],

  watch: {
    '$i18n.locale': 'setColumnHeaders',
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    setColumnHeaders() {
      switch (this.content_file.scale_version) {
        case 'XR5000PHONE':
          this.hotSettings.colHeaders = [...this.getColXR5000PHONE];
          break;

        case 'XR5000PC':
          this.hotSettings.colHeaders = [...this.getColXR5000PC];
          break;

        case 'XR3000':
          this.hotSettings.colHeaders = [...this.getColXR3000];
          break;

        default:
          this.hotSettings.colHeaders = [...this.getColHeaders];
          break;
      }
    },

    formatValue(value) {
      return Formatter.formatMoney(Number(value));
    },

    cleanFileList() {
      this.message = null;
      let file = this.content_file.name_file;

      SweetAlert.delete(file).then((result) => {
        if (result.value) {
          this.showHideLoading(true);
          Axios.postMasters({
            route: 'scales/clusters/delete',
            file: 'clusters/' + file,
          })
            .then((response) => {
              this.filesList.splice(
                this.filesList.indexOf('clusters/' + file),
                1
              );
              this.showHideLoading();
              this.renderer = false;
              this.hotSettings.data = [];
              this.file_sel =
                this.filesList.length > 0 ? this.filesList[0] : null;
              this.message = response.data.message;

              if (this.file_sel) {
                this.loadData();
              } else {
                this.notificationDeleteFile();
              }
            })
            .catch((error) => {
              this.showHideLoading();
              this.message = null;

              SweetAlert.warning(error.response.data.message);
            });
        } else {
          this.message = null;
          this.file_sel = 'clusters/' + this.content_file.name_file;
        }
      });
    },

    loadFiles() {
      this.message = null;
      this.renderer = false;
      this.hotSettings.data = [];
      this.file_sel = null;
      this.showHideLoading(true);

      Axios.postMasters({
        route: 'scales/clusters/listdirectory',
        farm_id: this.farm_id,
        directory: 'clusters',
      })
        .then((response) => {
          this.filesList = response.data.files;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    notificationDeleteFile() {
      if (this.message) {
        this.showNotification(
          `` + this.message + ``,
          'success',
          'nc-check-2',
          `${i18n.t('common_words.success_operation')}...`
        );
      }
    },

    loadData() {
      if (this.file_sel) {
        this.showHideLoading(true);
        Axios.postMasters({
          route: 'scales/clusters/getfilecontent',
          farm_id: this.farm_id,
          filename: this.file_sel,
        })
          .then((response) => {
            if (response.data && response.data.handsontable.length > 0) {
              this.content_file = response.data;
              this.errorMessage = response.data.errorMessage;
              switch (response.data.scale_version) {
                case 'XR5000PHONE':
                  this.hotSettings.colHeaders = [...this.getColXR5000PHONE];
                  this.hotSettings.columns = [
                    { data: 0, readOnly: true },
                    { data: 1, readOnly: true },
                    { data: 2 },
                    { data: 3, type: 'numeric' },
                    { data: 4 },
                    { data: 5 },
                    { data: 6 },
                    { data: 7 },
                    { data: 8 },
                    { data: 9 },
                    { data: 10, readOnly: true },
                  ];
                  break;

                case 'XR5000PC':
                  this.hotSettings.colHeaders = [...this.getColXR5000PC];
                  this.hotSettings.columns = [
                    { data: 0, readOnly: true },
                    { data: 1, readOnly: true },
                    { data: 2 },
                    { data: 3, type: 'numeric' },
                    { data: 4 },
                    { data: 5 },
                    { data: 6 },
                    { data: 7 },
                    { data: 8 },
                    { data: 9 },
                    { data: 10, readOnly: true },
                    { data: 11, readOnly: true },
                    { data: 12 },
                    { data: 13, readOnly: true },
                  ];
                  break;

                case 'XR3000':
                  this.hotSettings.colHeaders = [...this.getColXR3000];
                  this.hotSettings.columns = [
                    { data: 0, readOnly: true },
                    { data: 1, readOnly: true },
                    { data: 2, readOnly: true },
                    { data: 3 },
                    { data: 4, type: 'numeric' },
                    { data: 5 },
                    { data: 6 },
                    { data: 7 },
                    { data: 8 },
                    { data: 9 },
                    { data: 10 },
                  ];
                  break;

                default:
                  this.hotSettings.colHeaders = [...this.getColHeaders];
                  this.hotSettings.columns = [
                    { data: 0, readOnly: true },
                    { data: 1, readOnly: true },
                    { data: 2 },
                    { data: 3, type: 'numeric' },
                    { data: 4 },
                    { data: 5 },
                    { data: 6 },
                    { data: 7 },
                    { data: 8 },
                    { data: 9 },
                    { data: 10, readOnly: true },
                    { data: 11, readOnly: true },
                    { data: 12, readOnly: true },
                  ];

                  break;
              }

              this.renderer = false;
              this.hotSettings.data = this.content_file.handsontable;
              delete this.content_file.handsontable;

              sessionStorage.setItem(
                'ribbons_errors',
                JSON.stringify(this.content_file.ribbons_errors)
              );
              sessionStorage.setItem(
                'content_ribbons',
                JSON.stringify(this.content_file.content_ribbons)
              );
              sessionStorage.setItem(
                'ribbons',
                JSON.stringify(this.content_file.ribbons)
              );
              sessionStorage.setItem(
                'affiliates',
                JSON.stringify(this.content_file.affiliates)
              );
              sessionStorage.setItem(
                'lots_errors',
                JSON.stringify(this.content_file.lots_errors)
              );
              sessionStorage.setItem(
                'content_lots',
                JSON.stringify(this.content_file.content_lots)
              );
              sessionStorage.setItem(
                'lots',
                JSON.stringify(this.content_file.lots)
              );
              sessionStorage.setItem(
                'affiliates_lots',
                JSON.stringify(this.content_file.affiliates_lots)
              );

              this.clusters_names =
                Object.values(this.content_file.ribbons_errors).length == 0
                  ? null
                  : Object.values(this.content_file.ribbons_errors).join(', ');

              this.lots_names =
                Object.values(this.content_file.lots_errors).length == 0
                  ? null
                  : Object.values(this.content_file.lots_errors).join(', ');

              this.$nextTick(function () {
                this.renderer = true;
                this.drawBadRows();
              });
            }

            this.showHideLoading();
            this.notificationDeleteFile();
          })
          .catch((error) => {
            this.showHideLoading();
            this.notificationDeleteFile();
            SweetAlert.warning(error.response.data.message);
          });
      }
    },

    drawBadRows() {
      setTimeout(() => {
        const all = document
          .getElementsByClassName('htCore')[0]
          .getElementsByTagName('tbody')[0]
          .getElementsByTagName('tr');

        Array.from(all).forEach((item) => {
          let cluster = item.getElementsByTagName('td')[2];
          let ribbon = item.getElementsByTagName('td')[1];
          let lot = item.getElementsByTagName('td')[3];

          if (cluster.innerText != '') {
            for (let element of this.content_file.affiliates) {
              if (element.color_name == cluster.innerText.toUpperCase()) {
                cluster.style.background = element.color_code;
                cluster.style.color = element.color_text;
                ribbon.style.background = element.color_code;
                ribbon.style.color = element.color_text;
                ribbon.innerText = element.id;
                cluster.innerText = element.color_name;
                break;
              }
            }
          }

          if (
            cluster.innerText == '' ||
            Object.values(
              JSON.parse(sessionStorage.getItem('ribbons_errors'))
            ).includes(cluster.innerText.toUpperCase())
          ) {
            cluster.className = 'alert alert-danger';
          } else {
            cluster.className = '';
          }

          if (
            !Number.isInteger(parseInt(lot.innerText)) ||
            lot.innerText == '' ||
            Object.values(
              JSON.parse(sessionStorage.getItem('lots_errors'))
            ).includes(parseInt(lot.innerText))
          ) {
            lot.className = 'alert alert-danger';
          } else {
            lot.className = '';
          }
        });
      }, 10);
    },

    validate() {
      if (this.farm_id == null) {
        return this.validationInputsRequired('farm');
      } else if (this.file_sel == null) {
        return this.validationInputsRequired('file');
      } else {
        if (this.isCreate()) {
          this.showHideLoading(true);
          let data = {
            route: 'scales/clusters/savefilecontent',
            farm_id: this.farm_id,
            filename: this.file_sel,
            data_file: this.hotSettings.data,
            content_ribbons: this.content_file.content_ribbons,
            content_lots: this.content_file.content_lots,
            date_file: this.content_file.date_file,
            total: this.content_file.total,
            max_weight: this.content_file.max_weight,
            min_weight: this.content_file.min_weight,
            avg_weight: this.content_file.avg_weight,
            scale_version: this.content_file.scale_version,
          };

          Axios.postMasters(data)
            .then((response) => {
              this.showHideLoading();
              this.file_sel = null;
              this.renderer = false;
              this.hotSettings.data = [];
              this.content_file = null;
              this.clusters_names = null;
              this.lots_names = null;
              this.filesList = [];
              SweetAlert.success(response.data.message).then(() => {
                this.loadFiles();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        } else {
          this.showMessageAccess();
          this.message = null;

          this.showHideLoading();
        }
      }
    },

    validateFile() {
      this.message = null;
      this.showHideLoading(true);
      this.renderer = false;

      //this.$nextTick(function() {
      this.renderer = true;
      setTimeout(() => {
        let ribbons_errors = [];
        let ribbonsActually = [];
        let lots_errors = [];
        let lotsActually = [];
        let found = false;
        let foundLot = false;

        Object.values(this.hotSettings.data).forEach((item, key) => {
          if (item[2] != '') {
            for (
              let index = 0;
              index < Object.values(this.content_file.affiliates).length;
              index++
            ) {
              const element = Object.values(this.content_file.affiliates)[
                index
              ];
              if (
                element.color_name == item[2].toUpperCase() &&
                !ribbonsActually.includes(element.id)
              ) {
                ribbonsActually.push(element.id);
                item[1] = element.id;
                item[2] = item[2].toUpperCase();
                this.$set(this.hotSettings.data, key, item);
                found = true;
                break;
              } else {
                if (element.color_name == item[2].toUpperCase()) {
                  item[1] = element.id;
                  item[2] = item[2].toUpperCase();
                  this.$set(this.hotSettings.data, key, item);
                  break;
                }
              }
            }

            if (!found && !ribbons_errors.includes(item[2].toUpperCase())) {
              ribbons_errors.push(item[2].toUpperCase());
            }
          }

          if (
            item[2] == '' &&
            !ribbons_errors.includes(item[2].toUpperCase())
          ) {
            ribbons_errors.push(item[2].toUpperCase());
          }

          if (item[3] != '' || item[3] > 0) {
            if (
              !Number.isInteger(parseInt(item[3])) &&
              !lots_errors.includes(item[3])
            ) {
              lots_errors.push(item[3]);
            } else {
              for (
                let index = 0;
                index < Object.values(this.content_file.affiliates_lots).length;
                index++
              ) {
                const element = Object.values(
                  this.content_file.affiliates_lots
                )[index];
                if (
                  element.number_lot == item[3] &&
                  !lotsActually.includes(element.number_lot)
                ) {
                  lotsActually.push(element.number_lot);
                  foundLot = true;
                  break;
                } else {
                  foundLot = false;
                  if (element.number_lot == item[3]) {
                    foundLot = true;
                    break;
                  }
                }
              }

              if (!foundLot && !lots_errors.includes(item[3])) {
                lots_errors.push(item[3]);
              }
            }
          }

          if (
            (item[3] == '' || item[3] <= 0) &&
            !lots_errors.includes(item[3])
          ) {
            lots_errors.push(item[3]);
          }
        });

        let r = [];
        ribbonsActually.forEach((item) => {
          Object.values(this.content_file.affiliates).forEach((element) => {
            if (item == element.id) {
              r.push(element);
            }
          });
        });

        let l = [];
        lotsActually.forEach((item) => {
          Object.values(this.content_file.affiliates_lots).forEach(
            (element) => {
              if (item == element.number_lot) {
                l.push(element);
              }
            }
          );
        });

        this.clusters_names =
          ribbons_errors.length == 0 ? null : ribbons_errors.join(', ');
        this.content_file.content_ribbons = r;
        this.content_file.ribbons_errors = ribbons_errors;
        sessionStorage.setItem(
          'ribbons_errors',
          JSON.stringify(ribbons_errors)
        );
        sessionStorage.setItem('content_ribbons', JSON.stringify(r));

        this.lots_names =
          lots_errors.length == 0 ? null : lots_errors.join(', ');
        this.content_file.content_lots = l;
        this.content_file.lots_errors = lots_errors;
        sessionStorage.setItem('lots_errors', JSON.stringify(lots_errors));
        sessionStorage.setItem('content_lots', JSON.stringify(l));

        this.drawBadRows();
        this.showHideLoading();
      }, 1000);
      //})
    },

    syncScalesClusters() {
      this.showHideLoading(true);
      Axios.getMasters('scales/clusters/syncScalesClusters')
        .then((response) => {
          this.showHideLoading();
          SweetAlert.success(response.data.message);
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);

      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('scales/clusters/downloadScales')
        .then((response) => {
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('scales');
  },

  destroyed() {
    this.deselectedItemOnMenu('scales');
    sessionStorage.removeItem('ribbons_errors');
    sessionStorage.removeItem('ribbons');
    sessionStorage.removeItem('affiliates');
    sessionStorage.removeItem('content_ribbons');
    sessionStorage.removeItem('lots_errors');
    sessionStorage.removeItem('lots');
    sessionStorage.removeItem('affiliates_lots');
    sessionStorage.removeItem('content_lots');
  },
};
</script>
<style></style>
